import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { AlertContext } from "../../context/AlertContext";
import Spinner from "./Spinner";
import { AuthContext } from "../../context/AuthContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import { ConfiguracionContext } from "../../context/ConfiguracionContext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import CheckIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import ButtonMui from "@mui/material/Button";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import Menu from "./Menu";
import { saveAs } from "file-saver";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";
import Checkbox from "@mui/material/Checkbox";
import { OrderList } from "primereact/orderlist";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import CloseIcon from "@mui/icons-material/Close";

export default function ImportarComprobantes(props) {
  let navigate = useNavigate();
  const toast = useRef(null);
  const { origen } = useParams();
  const [visible, setVisible] = useState(true);
  const [comprobante, guardarComprobante] = useState(null);
  const [visibleCae, setVisibleCae] = useState(false);

  const [periodoConfirmado, setPeriodoConfirmado] = useState(false);

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    puntosVentas,
    empresaElegida,
    tiposComprobantes,
    comprobanteArca,
    obtenerAcceso,
    obtenerPuntosVentas,
    obtenerTiposComprobantesArca,
    obtenerComprobanteArca,
    guardarComprobanteArca,
    importarComprobanteArca,
  } = configuracionContext;

  //const classes = useStyles({color: afiliado ? afiliado.motivoConsultaColor : null });

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ImportarComprobantes",
      });
    }
  }, [state]);

  useEffect(() => {
    if (empresaElegida && empresaElegida.id) {
      obtenerPuntosVentas({ empresaId: empresaElegida.id });
      obtenerTiposComprobantesArca();
    }
  }, [empresaElegida]);

  const exitClick = (e) => {
    //navigate("/");
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Cierre Período",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const salir = (e) => {
    navigate("/");
  };

  const mensajeErrorArca = () => {
    toast.current.show({
      severity: "error",
      summary: "Información",
      detail: "No existe ese coprobante en A.R.C.A.",
      life: 3000,
    });
    guardarComprobanteArca(null);
  };

  const importarClick = (e) => {
    e.preventDefault();

    importarComprobanteArca({
      comprobante,
      cae: comprobanteArca.CodAutorizacion,
      vto:
        comprobanteArca.FchVto.substring(0, 4) +
        "-" +
        comprobanteArca.FchVto.substring(4, 6) +
        "-" +
        comprobanteArca.FchVto.substring(6, 8),
      empresa: empresaElegida,
      result: comprobanteArca.Resultado,
    });

    onHideComprobante();
  };

  const aceptarClick = (e) => {
    e.preventDefault();
    //Validar

    if (
      !comprobante ||
      comprobante.puntoVenta === undefined ||
      comprobante.puntoVenta === null ||
      comprobante.puntoVenta === "" ||
      comprobante.puntoVenta === 0
    ) {
      mensajeAlerta("A.R.C.A.", "Punto de venta es necesario !.", "error");
      return;
    }

    if (
      !comprobante ||
      comprobante.comprobanteId === undefined ||
      comprobante.comprobanteId === null ||
      comprobante.comprobanteId === "" ||
      comprobante.comprobanteId === 0
    ) {
      mensajeAlerta("A.R.C.A.", "Comprobante es necesario !.", "error");
      return;
    }

    if (
      !comprobante ||
      comprobante.numero === undefined ||
      comprobante.numero === null ||
      comprobante.numero === "" ||
      comprobante.numero === 0
    ) {
      mensajeAlerta("A.R.C.A.", "Número es necesario !.", "error");
      return;
    }

    // Llamar al context

    obtenerComprobanteArca({ empresa: empresaElegida, comprobante });
  };
  const onHide = (e) => {
    setVisible(false);
  };

  const onHideComprobante = (e) => {
    guardarComprobanteArca(null);
  };

  const renderHeader = () => {
    return (
      <div>
        <Tag value="Importación Comprobantes A.R.C.A."></Tag>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarClick}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHide}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const renderHeaderComprobante = () => {
    return (
      <div>
        <Tag
          value={
            "Comprobante " +
            comprobante.comprobante +
            "-" +
            comprobante.puntoVenta +
            "-" +
            comprobante.numero
          }
        ></Tag>
      </div>
    );
  };

  const renderFooterComprobante = () => {
    return (
      <div>
        <ButtonMui
          onClick={importarClick}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Importar
        </ButtonMui>
        <ButtonMui
          onClick={onHideComprobante}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  //console.log(comprobanteArca);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      <ConfirmDialog />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Dialog
            header={renderHeader()}
            visible={visible}
            closable={false}
            footer={renderFooter()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "50vw", paddingBottom: "0" }}
            position="left"
          >
            <Grid container spacing={3} style={{ marginTop: "1vw" }}>
              <Grid item xs={12} md={2} style={{ paddingTop: "0.2vw" }}>
                <Autocomplete
                  id="puntoVenta"
                  //disabled
                  fullWidth
                  options={
                    puntosVentas && empresaElegida
                      ? puntosVentas.filter(
                          (item) =>
                            item.habilitado &&
                            item.id_empresa === empresaElegida.id
                        )
                      : null
                  }
                  disablePortal
                  getOptionLabel={(option) => option.numeroPv}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label="P. Venta"
                      size="small"
                    />
                  )}
                  onChange={(event, value) => {
                    if (value) {
                      guardarComprobante({
                        ...comprobante,
                        puntoVenta: value.numeroPv,
                      });
                    } else {
                      guardarComprobante({
                        ...comprobante,
                        puntoVenta: null,
                      });
                    }
                  }}
                />
              </Grid>
              <Grid item xs={0.5} md={0.5} />

              <Grid item xs={12} md={9} style={{ padding: "0vw" }}>
                <Autocomplete
                  id="tipoComprobante"
                  fullWidth
                  noOptionsText={"No hay opciones"}
                  options={tiposComprobantes ? tiposComprobantes : null}
                  //defaultValue={tiposComprobantes[0]}
                  getOptionLabel={(option) => option.nombre}
                  openOnFocus={true}
                  disablePortal
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Comprobante *"
                      variant="standard"
                      InputLabelProps={{
                        style: { color: "red" },
                      }}
                    />
                  )}
                  //onKeyDown={handleEnter}
                  onChange={(event, value) => {
                    if (value) {
                      guardarComprobante({
                        ...comprobante,
                        comprobanteId: value.id,
                        comprobante: value.nombre,
                        comprobanteAbreviatura: value.abreviatura,
                        tipo: value.abreviatura.substring(
                          value.abreviatura.length - 1
                        ),
                      });
                    } else {
                      guardarComprobante({
                        ...comprobante,
                        comprobanteId: null,
                        comprobante: null,
                        comprobanteAbreviatura: null,
                        tipo: null,
                      });
                    }
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={3}
                style={{ padding: "0.2vw", marginLeft: "1vw" }}
              >
                <label htmlFor="numero" style={{ color: "red" }}>
                  Número
                </label>
                <InputNumber
                  inputId="numero"
                  value={comprobante ? comprobante.numero : null}
                  //onKeyDown={handleEnter}
                  onChange={(e) => {
                    guardarComprobante({
                      ...comprobante,
                      numero: e.value,
                    });
                  }}
                  size={6}
                  //mode="decimal"
                  //locale="en-US"
                  //minFractionDigits={0}
                  useGrouping={false}
                  style={{ marginLeft: "0.5vw", marginTop: "0.8vw" }}
                />
              </Grid>
            </Grid>
          </Dialog>

          {comprobanteArca  ? (
            <Dialog
              header={renderHeaderComprobante()}
              visible={visible}
              closable={false}
              footer={renderFooterComprobante()}
              breakpoints={{ "960px": "75vw" }}
              style={{ width: "50vw", paddingBottom: "0" }}
              position="right"
            >
              <Grid container spacing={3} style={{ marginTop: "1vw" }}>
                <Grid item xs={12} md={3}>
                  <TextField
                    value={
                      comprobanteArca.DocTipo === 80
                        ? "C.U.I.T."
                        : comprobanteArca.DocTipo === 99
                        ? "D.N.I."
                        : null
                    }
                    variant="standard"
                    id="tipoDoc"
                    label="Tipo Documento"
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    value={comprobanteArca.DocNro}
                    variant="standard"
                    id="numeroDocumento"
                    label="Número"
                    fullWidth
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    id="fecha"
                    label="Fecha"
                    type="date"
                    fullWidth
                    //onKeyDown={handleEnter}
                    value={
                      comprobanteArca.CbteFch.substring(0, 4) +
                      "-" +
                      comprobanteArca.CbteFch.substring(4, 6) +
                      "-" +
                      comprobanteArca.CbteFch.substring(6, 8)
                    }
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2} />

                <Grid item xs={12} md={3}>
                  <TextField
                    id="neto"
                    label="Neto"
                    fullWidth
                    //onKeyDown={handleEnter}
                    value={comprobanteArca.ImpNeto}
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    id="iva"
                    label="IVA"
                    fullWidth
                    //onKeyDown={handleEnter}
                    value={comprobanteArca.ImpIVA}
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    id="otros"
                    label="Otros Tributos"
                    fullWidth
                    //onKeyDown={handleEnter}
                    value={comprobanteArca.ImpTrib}
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    id="total"
                    label="Total"
                    fullWidth
                    //onKeyDown={handleEnter}
                    value={comprobanteArca.ImpTotal}
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    id="cae"
                    label="CAE"
                    fullWidth
                    //onKeyDown={handleEnter}
                    value={comprobanteArca.CodAutorizacion}
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    id="cvtoCe"
                    label="Vto. CAE"
                    type="date"
                    fullWidth
                    //onKeyDown={handleEnter}
                    value={
                      comprobanteArca.FchVto.substring(0, 4) +
                      "-" +
                      comprobanteArca.FchVto.substring(4, 6) +
                      "-" +
                      comprobanteArca.FchVto.substring(6, 8)
                    }
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
            </Dialog>
          ) : null}
          {comprobanteArca && comprobanteArca.Errors
            ? mensajeErrorArca()
            : null}
        </Fragment>
      ) : null}
    </Fragment>
  );
}
